// eslint-disable-next-line no-unused-vars
import React from 'react';
import { bool, string, object, func, number } from 'prop-types';
import { useContextSelector } from 'use-context-selector';

import OrderSummaryComponent from 'Components/Order/OrderSummary';
import { CartContext } from 'Contexts/CartContext';
import useUser from 'Hooks/useUser';
import usePermissions from 'Hooks/usePermissions';
import { CURRENCY_RON } from 'Constants';

const OrderSummary = (
  {
    order,
    orderType,
    totals,
    canPlaceStockReservationOrder = true,
    canShowButtons = true,
    canReserve = true,
    onPlaceOrder,
    loading,
    canPlaceOrder,
    displayVat,
    selectedDSCountry,
    hasSupplierProducts,
    productsType,
  }) => {
  const cartTotals = useContextSelector(CartContext, ({ data }) => ({
    total: data?.total,
    totalVat: data?.totalVat,
    totalWithVat: data?.totalWithVat,
  }));
  const { total, totalVat, totalWithVat } = totals || cartTotals;
  const onReserve = evt => onPlaceOrder(evt, 'reservation');
  const { data: user } = useUser();
  const { isExternalReseller } = usePermissions();
  let defaultCurrency;

  if (isExternalReseller) {
    defaultCurrency = order?.id ? order?.currencyId : user?.defaultCurrency;
  } else {
    defaultCurrency = order?.id ? order?.currencyId : CURRENCY_RON;
  }

  return (
    <OrderSummaryComponent
      loading={ loading }
      orderType={ orderType }
      canShowButtons={ canShowButtons }
      canPlaceStockReservationOrder={ canPlaceStockReservationOrder }
      canReserve={ canReserve }
      canPlaceOrder={ canPlaceOrder }
      isDropShipping={ order.dropShipment }
      dsCurrency={ order?.dropShipmentCurrency?.currencyId }
      onSubmit={ onPlaceOrder }
      defaultCurrency={ defaultCurrency }
      totals={ {
        price: total,
        vat: totalVat,
        transportValue: order.transportValue,
        total: totalWithVat,
        dsTotal: 'totalCashOnDelivery' in order
          ? order.totalCashOnDelivery
          : (order.items || [])
            .reduce((acc, prod) => {
              if (prod.promoItems) {
                (Object.values(prod.promoItems)?.at(0) || []).forEach(item => {
                  // eslint-disable-next-line no-param-reassign
                  acc += (item.cashOnDeliveryValue || 0);
                });
              }
              // eslint-disable-next-line no-param-reassign
              acc += (prod.cashOnDeliveryValue || 0);
              return acc;
            }, order.transportValue || 0)
      } }
      onReserve={ onReserve }
      displayVat={ displayVat }
      selectedDSCountry={ selectedDSCountry }
      hasSupplierProducts={ hasSupplierProducts }
      productsType={ productsType }
    />
  );
};
OrderSummary.propTypes = {
  order: object,
  orderType: string,
  totals: object,
  canReserve: bool,
  canShowButtons: bool,
  loading: bool,
  canPlaceStockReservationOrder: bool,
  canPlaceOrder: bool,
  onPlaceOrder: func,
  displayVat: bool,
  selectedDSCountry: number,
  hasSupplierProducts: bool,
  productsType: string,
};
OrderSummary.displayName = 'OrderSummaryContainer';
export default OrderSummary;
